import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { AuthRESTService } from '../../services/rest/auth-rest.service';
import { ToastrService } from "ngx-toastr";
import { TranslateService } from '@ngx-translate/core';
import Commons from "../../pages/commons";
import langs from "../../../../assets/languages.json";
import { UserLangResolverService } from '../../../services/user-lang-resolver';

@Component({
	selector: "language",
	templateUrl: "./language.component.html",
})
export class LanguageComponent extends Commons implements OnInit {

	public allLanguages: any[] = langs;
	public selectedLang: any;
	public toRemove: string;
	public userLangResolver: UserLangResolverService;
	@Output() onChange = new EventEmitter<string[]>();

	constructor(toastr: ToastrService, translate: TranslateService, private rest: AuthRESTService, userLangResolver: UserLangResolverService) {
		super(toastr, translate);
		this.userLangResolver = userLangResolver;
	}

	public ngOnInit() {}

	public addLanguage() {
		this.rest.post("translations", { code: this.selectedLang.code, content: {} },
			{ observe: 'response', responseType: 'text' }).subscribe((response) => {
				this.addSuccess('general.saved');
				this.translate.addLangs(this.translate.getLangs().concat(this.selectedLang.code));
				this.onChange.emit(this.translate.langs);
			},
				err => this.errorHandler(err),
			)
	}

	public removeLanguage(isConfirmed, code = undefined) {
		if (code) {
			this.toRemove = code;
		}
		if (isConfirmed && this.toRemove) {
			this.rest.delete("translations/" + this.toRemove,
				{ observe: 'response', responseType: 'text' }).subscribe((response) => {
					if (this.translate.currentLang === this.toRemove) {
						this.userLangResolver.changeLang(this.translate.getDefaultLang()).subscribe(() => {
							this.onLangRemoved();
						});
					} else {
						this.onLangRemoved();
					}

				},
					err => this.errorHandler(err),
				)
		}
	}

	public onLangRemoved() {
		this.translate.langs.splice(this.translate.langs.indexOf(this.toRemove), 1);
		this.onChange.emit(this.translate.langs);
		this.addSuccess('general.saved');
		this.toRemove = null;
	}

}
